export default "__VITE_ASSET__CjKddMeF__"